import { cn } from "@/lib/utils";
import { Check } from "lucide-react";

export default function EmergencySuccessCode() {
  return (
    <div
      className="absolute left-1/2 top-1/2 z-0 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
      aria-hidden
    >
      <div
        className={cn(
          "relative size-7.5 rounded-sm border-3 border-sig bg-transparent",
          "shadow-[0_0_10px_6px_rgba(14,89,198,0.4)]",
          "origin-center animate-in fade-in zoom-in-95 duration-300 ease-out",
          "transition-[box-shadow,opacity] duration-300 ease-out"
        )}
      >
        <div className="absolute -top-2.5 -left-[9px] z-1 rounded-full border-3 border-sig pointer-events-none animate-in fade-in duration-300 ease-out delay-75">
          <div className="relative z-1 flex size-4.5 items-center justify-center rounded-full bg-white">
            <Check
              className="size-3 shrink-0 text-sig"
              strokeWidth={3}
              aria-hidden
            />
          </div>
        </div>
      </div>
    </div>
  );
}
